module.exports = __webpack_public_path__ + "assets/img/image.353d9332.svg";